export function rethrowLegacyAuthError(error) {
  if (error && typeof error === 'object' && !error.code && error.name) {
    error.code = error.name
  }
  throw error
}
